import { EpStepContent } from '../HookFormComponents/components';
import './EpCheckboxGroup.module.scss';

type EpCheckboxGroupProps = {
  legend: string;
  children: React.ReactNode;
};

export const EpCheckboxGroup = ({ legend, children }: EpCheckboxGroupProps) => {
  return <EpStepContent.Label label={legend}>{children}</EpStepContent.Label>;
};
